import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	months: {
		id: 'servicedesk-reports-common.common.summary.utils.months',
		defaultMessage: 'mths',
		description: 'Label suffixed next to month value',
	},
	days: {
		id: 'servicedesk-reports-common.common.summary.utils.days',
		defaultMessage: 'days',
		description: 'Label suffixed next to days value',
	},
	hours: {
		id: 'servicedesk-reports-common.common.summary.utils.hours',
		defaultMessage: 'hrs',
		description: 'Label suffixed next to hours value',
	},
	minutes: {
		id: 'servicedesk-reports-common.common.summary.utils.minutes',
		defaultMessage: 'mins',
		description: 'Label suffixed next to minutes value',
	},
	percentage: {
		id: 'servicedesk-reports-common.common.summary.utils.percentage',
		defaultMessage: '%',
		description: 'Label suffixed next to percentage value',
	},
});
